import { ReducerEntityPrefixTypes, ReducerNamespaceTypes } from "enums";
import { type FiltersEnum } from "features/Accounts/AllAccountsOverview/types";
import { type FiltersState, createFiltersSlice } from "features/Application/slices/createFiltersSlice";
import { type GenericFiltersMap } from "utils/filterUtils";

export interface GroupMembersFiltersState extends FiltersState<FiltersEnum> {
  search?: string;
}

export const initialState: GroupMembersFiltersState = {
  filterOptions: {} as GenericFiltersMap<FiltersEnum>,
  appliedFilter: {} as GenericFiltersMap<FiltersEnum>,
  isLoading: false,
};

const groupMembersFiltersSlice = createFiltersSlice({
  namePayload: {
    namespace: ReducerNamespaceTypes.People,
    entity: ReducerEntityPrefixTypes.AddGroup,
    name: "filters",
  },
  initialState,
  reducers: {},
});

export const {
  setAppliedFilter,
  resetAppliedFilter,
  setIsLoading,
  setSearch,
  resetSearch,
  setFilterOptions,
  resetFilter,
} = groupMembersFiltersSlice.actions;

export default groupMembersFiltersSlice.reducer;
